import { VenueMappingsResponse } from 'widgets/darkVenueHeatmap/venueMappings/types.ts';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type DarkVenueMappingState = { mappings: VenueMappingsResponse };

export const initialDarkVenueMappingsState: DarkVenueMappingState = {
    mappings: {},
};

const slice = createSlice({
    name: 'darkVenueMappings',
    initialState: initialDarkVenueMappingsState,
    reducers: {
        setDarkVenueMappings: (
            state,
            action: PayloadAction<VenueMappingsResponse>
        ) => {
            state.mappings = action.payload;
        },
    },
});

export default slice.reducer;

export const { setDarkVenueMappings } = slice.actions;
